module.exports = __webpack_public_path__ + "media/images/athletes/1663-fb4481d37ac5b1643494676775f2fd11.png";